import React from "react";
import { Navigate, useParams } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard/Index";
import FirmDashboard from "../pages/Dashboard/FirmIndex";
import FirmAdminDashboard from "../pages/Dashboard/FirmAdminDashboard";
import GettingStarted from "../pages/GettingStarted/GettingStarted";
import PostLoginLanding from "../pages/Authentication/PostLoginLanding";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import LoginPassword from "../pages/Authentication/LoginPassword";
import Logout from "../pages/Authentication/Logout";
import SignedOut from "../pages/Authentication/SignedOut";
import TwoStepVerfication from "../pages/Authentication/TwoStepVerfication";

import Masters from "../pages/Masters/Index";
import SystemMasters from "../pages/Masters/SystemIndex";

import Subscriptions from "../pages/Company/Subscriptions";
import CompanyList from "../pages/Company/CompanyList";
import ClientList, { ClientDetailsPage } from "../pages/Clients/ClientList";
import SystemTemplates from "../pages/Template/SysTemplateIndex";
import ReviewTemplateCreatePage from "../pages/Template/ReviewTemplateCreatePage";
import ImportDefinitionWizardPage from "../pages/Template/ImportDefinitionWizardPage";
import ImportDefinitionViewPage from "../pages/Template/ImportDefinitionViewPage";
import SystemStandards from "../pages/Standards/StandardIndex";
import SystemChecklist from "../pages/Checklists/ChecklistIndex";
import ChecklistImportWizard from "../pages/Checklists/ChecklistImportWizard";
import ChecklistPreview from "../pages/Checklists/ChecklistPreview";

import ReviewTasks from "../pages/InspectionReviews/ReviewTasks";
import InspectionJourneyPage from "../pages/InspectionJourney/InspectionJourneyPage";
import InspectionCycleList from "../pages/InspectionCycles/InspectionCycleList";
import EngagementList from "../pages/Engagements/EngagementList";
import EngagementWorkspacePage from "../pages/Engagements/EngagementWorkspacePage";
import EngagementCreatePage from "../pages/Engagements/EngagementCreatePage";
import EngagementPreviewPage from "../pages/Engagements/EngagementPreviewPage";
import DataImportWizardPage from "../pages/DataImport/DataImportWizardPage";
import InspectionReviewPage from "../pages/InspectionReviews/InspectionReviewPage";
import InspectionWorkspaceIndex from "../pages/InspectionReviews/InspectionWorkspaceIndex";
import InspectionCycleCreatePage from "../pages/InspectionCycles/InspectionCycleCreatePage";
import InspectionCyclePreviewPage from "../pages/InspectionCycles/InspectionCyclePreviewPage";

import SettingsSecurity from "../pages/Security/Security";
import SettingsSysSecurity from "../pages/Security/SysSecurity";
import DataImportList from "../pages/DataManagement/DataImportList";

//settings
import SettingsRMS from "../pages/Settings/Index";
import SettingsMeetings from "../pages/Settings/MeetingIndex";

//reports
import ExamReport from "../pages/Reports/ExamReport";
import ProgressReport from "../pages/Reports/ProgressReport";
import FacultyReport from "../pages/Reports/FacultyReport";
import TargetReport from "../pages/Reports/TargetReport";
import ReportMenu from "../pages/Reports/ReportMenu";
import FirmReportMenu from "../pages/Reports/FirmReportMenu";
import InspectionCycleReport from "../pages/Reports/InspectionCycleReport";
import ReportDetail from "../pages/Reports/ReportDetail";
import HelpIndex from "../pages/Help/help";
import UserProfile from "../pages/Authentication/user-profile";
import NotificationsPage from "../pages/Notifications/NotificationsPage";
import NotificationSettingsPage from "../pages/Notifications/NotificationSettingsPage";

const InspectionCycleEngagementRedirect = () => {
  const { cycleId } = useParams();
  return (
    <Navigate to={`/inspections/${cycleId}/edit?step=engagements`} replace />
  );
};

import SwitchFirm from "../pages/Company/SwitchFirm";

const userRoutes = [
  { path: "/switch-firm", element: SwitchFirm },
  //dashboard
  { path: "/dashboard", element: Dashboard },
  { path: "/piers/dashboard", element: FirmDashboard },
  { path: "/piers/dashboard/inspections", element: FirmDashboard },
  { path: "/piers/dashboard/my-work", element: FirmDashboard },
  { path: "/piers/dashboard/resources", element: FirmDashboard },
  { path: "/piers/getting-started", element: GettingStarted },
  { path: "/piers/landing", element: PostLoginLanding },
  { path: "/firm/dashboard", element: FirmAdminDashboard },
  { path: "/projects/dashboard", element: Dashboard },
  { path: "/inspections/list", element: InspectionCycleList },
  { path: "/inspections/new", element: InspectionCycleCreatePage },
  { path: "/inspections/:cycleId/edit", element: InspectionCycleCreatePage },
  {
    path: "/inspections/:cycleId/preview",
    element: InspectionCyclePreviewPage,
    layout: "full-screen",
  },
  {
    path: "/inspections/:cycleId/engagements/setup",
    element: InspectionCycleEngagementRedirect,
  },
  {
    path: "/inspections/:cycleId/engagements/add",
    element: InspectionCycleEngagementRedirect,
  },
  { path: "/inspections/overview", element: FirmDashboard },
  {
    path: "/inspections/:cycleId/engagements",
    element: InspectionCycleEngagementRedirect,
  },
  {
    path: "/inspections/:cycleId/engagements/:engagementId/:stage",
    element: InspectionJourneyPage,
  },
  { path: "/piers/masters", element: Masters },
  { path: "/system/masters", element: SystemMasters },
  { path: "/engagements/list", element: EngagementWorkspacePage },
  { path: "/engagements/import", element: DataImportWizardPage },
  {
    path: "/engagements/import/history",
    element: () => <Navigate to="/piers/dataimport" replace />,
  },
  { path: "/engagements/new", element: EngagementCreatePage },
  { path: "/engagements/:engagementId/edit", element: EngagementCreatePage },
  {
    path: "/engagements/:engagementId/preview",
    element: EngagementPreviewPage,
  },
  { path: "/engagements/assigned", element: EngagementList },
  { path: "/engagements/in-progress", element: EngagementList },
  { path: "/engagements/awaiting-queries", element: EngagementList },
  { path: "/engagements/in-review", element: EngagementList },
  { path: "/engagements/completed", element: EngagementList },
  { path: "/engagements/archived", element: EngagementList },
  {
    path: "/inspectionreviews/list",
    element: () => <Navigate to="/inspections/list" replace />,
  },
  {
    path: "/inspectionreview/:inspectionreviewId",
    element: InspectionReviewPage,
    layout: "full-screen",
  },
  {
    path: "/inspectionreview/:inspectionreviewId/checklist",
    element: () => <InspectionReviewPage checklist />,
    layout: "full-screen",
  },
  { path: "/review-tasks", element: ReviewTasks },
  {
    path: "/tasks/list",
    element: () => <Navigate to="/review-tasks" replace />,
  },
  {
    path: "/queries",
    element: () => <InspectionWorkspaceIndex type="queries" />,
  },
  {
    path: "/findings",
    element: () => <InspectionWorkspaceIndex type="findings" />,
  },
  {
    path: "/inspection-reports",
    element: () => <InspectionWorkspaceIndex type="reports" />,
  },
  { path: "/firm/list", element: CompanyList },
  { path: "/system/subscriptions", element: Subscriptions },
  { path: "/clients/list", element: ClientList },
  { path: "/clients/:clientId", element: ClientDetailsPage },
  { path: "/system/templates", element: SystemTemplates },
  {
    path: "/system/templates/import-definitions/new",
    element: ImportDefinitionWizardPage,
  },
  {
    path: "/system/templates/import-definitions/:id/edit",
    element: ImportDefinitionWizardPage,
  },
  {
    path: "/system/templates/import-definitions/:id/view",
    element: ImportDefinitionViewPage,
  },
  {
    path: "/system/templates/review/new",
    element: ReviewTemplateCreatePage,
  },
  { path: "/system/templates/review/:templateId/edit", element: ReviewTemplateCreatePage },
  { path: "/system/standards", element: SystemStandards },
  { path: "/system/checklist", element: SystemChecklist },
  {
    path: "/system/checklist/import",
    element: ChecklistImportWizard,
    layout: "full-screen",
  },
  { path: "/system/checklist/:id/preview", element: ChecklistPreview },

  //Settings
  { path: "/firm/settings", element: SettingsMeetings },
  { path: "/settings/security", element: SettingsSecurity },
  { path: "/settings/syssecurity", element: SettingsSysSecurity },

  // reports
  { path: "/reports/examreport", element: ExamReport },
  { path: "/reports/progressreport", element: ProgressReport },
  { path: "/reports/facultyreport", element: FacultyReport },
  { path: "/reports/targetreport", element: TargetReport },
  { path: "/reports", element: ReportMenu },
  { path: "/reports/engagements", element: ReportMenu },
  { path: "/reports/my-reports", element: ReportMenu },
  { path: "/piers/reports", element: FirmReportMenu },
  { path: "/piers/reports/inspection-cycle", element: InspectionCycleReport },
  { path: "/piers/reports/:reportId", element: ReportDetail },

  // Data Import
  { path: "/piers/dataimport", element: DataImportList },
  { path: "/notifications", element: NotificationsPage },
  { path: "/notifications/settings", element: NotificationSettingsPage },

  //profile
  { path: "/profile", element: UserProfile },
  // this route should be at the end of all other routes
  { path: "/help", element: HelpIndex, layout: "help" },
];

const authRoutes = [
  //authencation page
  { path: "/", element: Login },
  { path: "/logout", element: Logout },
  { path: "/signed-out", element: SignedOut },
  { path: "/signin", element: Login },
  { path: "/login", element: Login },
  { path: "/verifypassword", element: LoginPassword },
  { path: "/forgot-password", element: <Navigate to="/signin" replace /> },
  { path: "/twostepverification", element: TwoStepVerfication },
];

export { userRoutes, authRoutes };
